
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10.021","cy":"3.096","r":"3.096"}}),_c('circle',{attrs:{"cx":"3.096","cy":"8.225","r":"3.096"}}),_c('circle',{attrs:{"cx":"5.717","cy":"16.12","r":"3.096"}}),_c('circle',{attrs:{"cx":"14.376","cy":"16.12","r":"3.096"}}),_c('circle',{attrs:{"cx":"16.904","cy":"8.215","r":"3.096"}})])
          )
        }
      }
    